import React, { useState } from 'react';
import { Colors, SmallIconButton } from 'library';
import IosShareIcon from '@mui/icons-material/IosShare';
import { ShareProviderProfile } from './ShareProviderProfile';
import { track } from 'shared';
import { Provider } from 'models';
import { isLoggedIn } from 'api/UserApi';
import usePublicSessionTracking, { PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';

export default function ShareProviderProfileAction({ provider }: { provider: Provider }) {
    const [open, setOpen] = useState(false);

    const { trackSession } = usePublicSessionTracking('Share Provider Profile Action');

    const share = () => {
        if (!isLoggedIn()) {
            trackSession('DIALOG_OPEN', 'Opened share provider profile', PublicSessionEventType.User, {
                provider: provider.id,
            });
        }

        track('Opened share provider profile', { provider, isLoggedIn: isLoggedIn() });
        setOpen(true);
    };

    return (
        <>
            <SmallIconButton
                icon={IosShareIcon}
                onClick={share}
                backgroundColor={Colors.white}
                shadow
                hoverText="Share Provider Profile"
                style={{ marginRight: 0 }}
            />
            {open ? (
                <ShareProviderProfile
                    open={open}
                    onClose={() => {
                        track('Closed share provider dialog');
                        setOpen(false);
                    }}
                    provider={provider}
                />
            ) : null}
        </>
    );
}
